import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Input,
  NgZone,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RecaptchaService } from '../../services/recaptcha.service';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RecaptchaComponent),
      multi: true,
    },
  ],
})
export class RecaptchaComponent
  implements ControlValueAccessor, AfterViewInit, OnDestroy
{
  @Input() siteKey = '';

  @ViewChild('recaptchaContainer', { static: true })
  recaptchaContainer!: ElementRef<HTMLDivElement>;

  widgetId?: number;
  onChange: (value: string | null) => void = () => {};
  onTouched: () => void = () => {};

  constructor(
    private recaptchaService: RecaptchaService,
    private ngZone: NgZone,
  ) {}

  ngAfterViewInit(): void {
    if (!this.siteKey) return;

    this.recaptchaService
      .render(
        this.recaptchaContainer.nativeElement,
        this.siteKey,
        (token) => {
          this.ngZone.run(() => {
            this.onChange(token);
            this.onTouched();
          });
        },
        () => {
          this.ngZone.run(() => {
            this.onChange(null);
            this.onTouched();
          });
        },
      )
      .then((widgetId) => (this.widgetId = widgetId));
  }

  ngOnDestroy(): void {
    if (this.widgetId !== undefined) {
      this.recaptchaService.reset(this.widgetId);
    }
  }

  writeValue(value: string | null): void {
    if (!value && this.widgetId !== undefined) {
      this.recaptchaService.reset(this.widgetId);
    }
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
